<template>
  <div class="cloud-server">
    <template v-if="!isShow">
      <!-- <p class="tw-text-primary">{{ $t(item.title) }}</p> -->
      <!-- <div class="tw-h-4"></div> -->
      <cloud-search @search="onSearch" @reset="onReset"></cloud-search>
      <b-overlay class="tw-mt-2" :show="loading" rounded="sm">
        <b-table
          :items="items"
          :fields="fields"
          head-variant="light"
          sticky-header="600px"
          no-border-collapse
          :responsive="true"
          class="custom-table-borders"
          :style="items.length > 0 ? { maxHeight: '660px' } : {}"
        >
          <!-- 自定义操作列 -->
          <template #cell(actions)="{ item }">
            <b-button
              variant="primary"
              class="mr-2"
              size="sm"
              @click="onView(item, true)"
              >{{ $t("查看") }}</b-button
            >
            <b-button
              variant="outline-primary"
              class="mr-2"
              size="sm"
              @click="renewOrder(item)"
              >{{ $t("续费") }}</b-button
            >
          </template>
        </b-table>
      </b-overlay>

      <!-- 暂无数据 -->
      <no-data v-if="!items.length"></no-data>

      <!-- 分页 -->
      <div
        v-if="total > 0"
        class="d-flex justify-content-between tw-items-center tw-mt-5 tw-mb-5"
      >
        <span class="tw-ml-4 tw-text-sm md:tw-text-base"
          >共{{ totalPages }}页，当前第{{ page.pageIndex }}页</span
        >
        <b-pagination
          v-model="page.pageIndex"
          :total-rows="total"
          :per-page="10"
          size="sm"
          @change="handleChangePage"
        ></b-pagination>
      </div>
    </template>

    <cloud-view
      v-else
      :item="viewItem"
      @back="onView(null, false)"
    ></cloud-view>
  </div>
</template>

<script>
import NoData from "@/components/no-data/no-data.vue";
import CloudSearch from "../components/cloud-search.vue";
import CloudView from "../components/cloud-view.vue";
import { cloudServerHeader } from "../data";
import { getServerList } from "@/api/cloudWord";
export default {
  name: "cloud-server",
  props: {
    item: {
      type: Object,
      default: {},
    },
  },

  components: {
    CloudSearch,
    CloudView,
    NoData,
  },
  data() {
    return {
      loading: false,
      // 是否查看
      isShow: false,
      // 搜索条件
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      // 总条数
      total: 0,
      // 表格数据
      items: [],
      viewItem: {},
      // 遮罩
      show: true,
    };
  },
  computed: {
    // 表头数据
    fields() {
      return cloudServerHeader();
    },
    // 总页数
    totalPages() {
      return Math.ceil(this.total / 10);
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.onGetList();
      }
    },
  },
  created() {
    this.onGetList();
  },
  methods: {
    // 方法区
    async onGetList() {
      this.loading = true;
      const params = {
        ...this.page,
        productId: this.$route.params.id,
      };
      const { code, data } = await getServerList(params);
      this.loading = false;
      if (code !== 0) return;
      // 规格
      this.items = data?.list?.sort((a, b) => a.id - b.id) || [];
      this.total = data.total;
      this.show = false;
    },
    // 查看
    onView(row, show) {
      this.isShow = show;
      this.viewItem = row;
    },
    // 续费
    renewOrder(row) {
      localStorage.setItem("currentItem", JSON.stringify(row));
      this.$store.commit("SET_ORDERTYPE", "cloud-renewed");
      this.$store.commit("SET_CURRENTSTEP", "confirm");
      this.$router.push({
        path: "/controlCenter/renewal-management",
      });
    },
    // 搜索
    onSearch(value) {
      this.page = { pageIndex: 1, pageSize: 20, ...value };
      this.onGetList();
    },
    // 重置
    onReset() {
      this.page = { pageIndex: 1, pageSize: 20 };
      this.onGetList();
    },
    // 切换分页
    handleChangePage(num) {
      this.page.pageIndex = num;
      this.onGetList();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 自定义表头样式 */
::v-deep .table .thead-light th {
  border-bottom: 1px solid #f3f3f3;
  border-top: 1px solid #f3f3f3;
  background-color: #f4f4f4;
  position: sticky !important;
  white-space: nowrap;
  z-index: 10 !important;
}

::v-deep .table td {
  white-space: nowrap;
}
@media (max-width: 768px) {
  .cloud-server {
    ::v-deep .sticky-column {
      position: sticky;
      right: 0;
      background: white;
      z-index: 2;
      box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
    }

    ::v-deep .table-responsive {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    ::v-deep .table {
      min-width: 100%;
    }
  }
}
</style>
